export const GET_HKI_REQUEST = 'GET_HKI_REQUEST';
export const GET_HKI_SUCCESS = 'GET_HKI_SUCCESS';
export const GET_HKI_FAILURE = 'GET_HKI_FALIURE';

export const GET_DETAIL_HKI_REQUEST = 'GET_DETAIL_HKI_REQUEST';
export const GET_DETAIL_HKI_SUCCESS = 'GET_DETAIL_HKI_SUCCESS';
export const GET_DETAIL_HKI_FAILURE = 'GET_DETAIL_HKI_FALIURE';

export const SET_DETAIL_MEREK = 'SET_DETAIL_MEREK'
export const SET_EXPAND = 'SET_EXPAND'